'use strict';

module.exports = inlineHeaders;

var querystring = require('querystring');

function inlineHeaders(url, headers) {
  if (/\?/.test(url)) {
    url += '&';
  } else {
    url += '?';
  }

  return url + querystring.encode(headers);
}



/*****************
 ** WEBPACK FOOTER
 ** ./~/algoliasearch/src/browser/inline-headers.js
 ** module id = 88
 ** module chunks = 0
 **/